import(/* webpackMode: "eager" */ "/vercel/path0/src/app/craft/page.tsx");
